// TODO: remove nextStatus when WebSocket update is implemented

export function isInvoicingSessionCancelled(appointment, nextStatus) {
  if (nextStatus) {
    if (nextStatus === "complete") {
      return false;
    } else if (["no_show", "late_cancel", "cancel"].includes(nextStatus)) {
      return true;
    }
  } else {
    if (!appointment.statusFlags.usingInvoicing) {
      return false;
    } else if (
      appointment.statusFlags.usingInvoicing &&
      appointment.statusFlags.cancelledOrAbandoned
    ) {
      return true;
    } else if (!appointment.invoice) {
      return false;
    } else if (
      ["no_show", "late_cancel", "cancel"].includes(
        appointment.invoice.appointment_status,
      )
    ) {
      return true;
    }
  }
}

export function isInvoicingSessionCancelledByPro(appointment, nextStatus) {
  if (nextStatus) {
    if (nextStatus === "cancel") {
      return true;
    } else {
      return false;
    }
  } else {
    if (!appointment.statusFlags.usingInvoicing) {
      return false;
    } else if (
      appointment.statusFlags.usingInvoicing &&
      appointment.statusFlags.cancelledOrAbandonedByOrchidPro
    ) {
      return true;
    } else if (!appointment.invoice) {
      return false;
    } else if (appointment.invoice.appointment_status === "cancel") {
      return true;
    }
  }
}

export function isNonInvoicedInvoicingSessionCancelled(appointment) {
  return (
    appointment.statusFlags.usingInvoicing &&
    !appointment.invoice &&
    (appointment.statusFlags.cancelledByOrchidPro ||
      appointment.statusFlags.cancelledByPatient)
  );
}

export function isNonInvoicedInvoicingSessionCancelledByPro(appointment) {
  return (
    appointment.statusFlags.usingInvoicing &&
    !appointment.invoice &&
    appointment.statusFlags.cancelledByOrchidPro
  );
}

export function isNonInvoicedInvoicingSessionCancelledByPatient(appointment) {
  return (
    appointment.statusFlags.usingInvoicing &&
    !appointment.invoice &&
    appointment.statusFlags.cancelledByPatient
  );
}
